import { render, staticRenderFns } from "./CprPlusLabelPop.vue?vue&type=template&id=a9ab942e&scoped=true&"
import script from "./CprPlusLabelPop.vue?vue&type=script&lang=js&"
export * from "./CprPlusLabelPop.vue?vue&type=script&lang=js&"
import style0 from "./CprPlusLabelPop.vue?vue&type=style&index=0&id=a9ab942e&prod&lang=scss&scoped=true&"
import style1 from "./CprPlusLabelPop.vue?vue&type=style&index=1&id=a9ab942e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ab942e",
  null
  
)

export default component.exports